// Rekenmotor voor de systeemkeuze-calculator van Simply Offgrid.
// Pure functie: advies(antwoorden, config) → advies-object. Geen DOM, geen netwerk,
// zodat hij buiten Shopify te testen is en in het thema ongewijzigd mee kan.
//
// Antwoorden (alles optioneel behalve land en situatie):
//   land: 'NL' | 'BE', gewest: 'Vlaanderen' | 'Wallonië' | 'Brussel'
//   situatie: 'ess' | 'solar-net' | 'solar-offgrid'
//   fase: '1' | '3' | null, doelen: ['noodstroom','zelfverbruik','dynamisch','offgrid']
//   noodstroom: 'alles' | 'groepen' | 'nee', zwareVerbruikers: ['warmtepomp','laadpaal','inductie','boiler','airco']
//   jaarverbruikKwh, verbruikEuroMaand, huishouden: 'klein' | 'gemiddeld' | 'groot'
//   ampere (hoofdzekering per fase), bestaandePvKw (AC-vermogen PV-omvormer), bestaandePvFase: '1' | '3'
//   woningType (off-grid): 'tiny' | 'chalet' | 'woning'
//   dakPanelenMax, orientatie: 'zuid' | 'oost-west' | 'noord'
//   accuPlek: 'binnen' | 'schuur' | 'trap-kelder', aggregaat: bool, wilAdvies: bool
//   installatie: bool, postcode

(function (root) {
  const r1 = (x) => Math.round(x * 10) / 10;
  const nl = (x) => String(r1(x)).replace('.', ',');
  const euro = (x) => '€' + Math.round(x).toLocaleString('nl-NL');
  const accuLabel = (C, v) => C.accu.merken[v.merk].naam + ' ' + nl(v.kwh) + ' kWh (' + v.modules + (v.modules === 1 ? ' module)' : ' modules)');
  const heeft = (lijst, x) => Array.isArray(lijst) && lijst.includes(x);

  function advies(a, C) {
    const uit = {
      versie: C.versie, status: 'set', route: a.situatie, set: null, config: {},
      waarom: [], meldingen: [], alternatieven: [], maatwerkRedenen: [], besparing: null, installatie: null,
    };
    const maatwerk = (reden) => uit.maatwerkRedenen.push(reden);
    const zwaar = (a.zwareVerbruikers || []).filter((z) => C.zwareVerbruikers.includes(z));

    // --- Basischecks ---------------------------------------------------------
    if (a.land === 'BE' && a.gewest && a.gewest !== 'Vlaanderen') maatwerk('België buiten Vlaanderen: andere regels in ' + a.gewest + '.');
    if (a.aggregaat && a.situatie !== 'solar-offgrid') maatwerk('Net én aggregaat vraagt een Quattro; die zit niet in de sets.');
    if (a.situatie === 'solar-offgrid' && heeft(a.zwareVerbruikers, 'warmtepomp')) maatwerk('Off-grid met een warmtepomp: dat rekenen we liever samen door.');
    if (a.wilAdvies) maatwerk('Je gaf aan dat je liever advies wilt.');

    let fase = a.fase;
    if (!fase) {
      fase = '1';
      uit.meldingen.push('Je weet niet of je 1- of 3-fase hebt. We rekenen met 1-fase; kijk in de meterkast (3 hoofdschakelaars of een brede hoofdschakelaar = 3-fase).');
    }

    // --- Verbruik ------------------------------------------------------------
    let jaar = a.jaarverbruikKwh;
    let verbruikGeschat = false;
    if (!jaar && a.verbruikEuroMaand) {
      const tarief = C.besparing[a.land || 'NL'].waardeKwh[1] + 0.02; // ruwe all-in prijs
      jaar = Math.round((a.verbruikEuroMaand * 12) / tarief);
      verbruikGeschat = true;
    }
    if (!jaar) {
      const type = a.situatie === 'solar-offgrid' ? C.verbruik.offgridWoning[a.woningType || 'woning'] : a.huishouden || 'gemiddeld';
      jaar = C.verbruik.huishouden[type];
      for (const z of a.zwareVerbruikers || []) jaar += C.verbruik.extraZwaar[z] || 0;
      verbruikGeschat = true;
    }
    const dag = jaar / 365;
    uit.config.jaarverbruikKwh = jaar;
    if (verbruikGeschat) uit.meldingen.push('Je verbruik is geschat op ' + jaar + ' kWh per jaar. Met je echte jaarverbruik (energierekening) wordt het advies preciezer.');

    // --- Set en omvormer -----------------------------------------------------
    // Drie technische regels (plan §3, Joris 20-10):
    // 1. Doorvoer: bij noodstroom op het hele huis loopt al het verbruik door de Multi. Die mag niet minder
    //    doorlaten dan de hoofdzekering (4k5 en 3000: 32 A, 6k5: 50 A).
    // 2. Bestaande PV op de noodstroom: per fase niet meer dan de Multi (factor 1,0).
    // 3. Vermogen bij een storing of off-grid: de zware verbruikers die dan moeten draaien.
    const opNoodstroom = a.situatie === 'solar-offgrid' || a.noodstroom === 'alles' || heeft(a.doelen, 'offgrid');
    const zwaarNood = opNoodstroom ? zwaar : [];
    const pvPerFase = (f) => {
      const pv = a.bestaandePvKw || 0;
      if (f === '1') return pv;
      return (a.bestaandePvFase || (pv > C.zwaardereOmvormer.pvEenFaseTot ? '3' : '1')) === '3' ? pv / 3 : pv;
    };
    const redenen = [];
    const kiesOmvormer = (setKey) => {
      const f = C.sets[setKey].fase;
      const Z = C.zwaardereOmvormer;
      if (setKey === 'solar-easy') return zwaar.length ? 'easy4000' : 'easy3000';
      const basis = f === '1' ? '1x4k5' : a.land === 'BE' && !zwaar.length && !heeft(a.zwareVerbruikers, 'laadpaal') ? '3x3000' : '3x4k5';
      const groot = f === '1' ? '1x6k5' : '3x6k5';
      const per = (k) => C.omvormers[k].va / (f === '3' ? 3 : 1);
      redenen.length = 0;
      const ampere = a.ampere || (f === '1' ? Z.standaardAmpere1f : Z.standaardAmpere3f);
      if (opNoodstroom && a.situatie !== 'solar-offgrid' && ampere > C.omvormers[basis].doorvoerA) {
        redenen.push('Bij noodstroom op het hele huis loopt al je verbruik door de omvormer. Een ' + C.omvormers[basis].label + ' laat ' + C.omvormers[basis].doorvoerA + ' A door; je aansluiting is ' + (a.ampere ? a.ampere + ' A' : 'waarschijnlijk 35–40 A') + '. De 6k5 laat 50 A door.');
        if (!a.ampere) uit.meldingen.push('Kijk op je hoofdzekering hoeveel ampère je hebt. Bij 1x25A volstaat ook de 4k5.');
      }
      if (pvPerFase(f) > per(basis)) redenen.push('Je bestaande panelen leveren per fase meer dan de ' + C.omvormers[basis].label + ' aankan, daarom de 6k5.');
      const zwaarDrempel = f === '1' ? (heeft(zwaarNood, 'inductie') || zwaarNood.length >= 2) : zwaarNood.length >= Z.zwareVerbruikersVanaf3f;
      if (zwaarDrempel) redenen.push('Bij een storing' + (a.situatie === 'solar-offgrid' ? ' of off-grid' : '') + ' moeten je zware verbruikers (' + zwaarNood.join(', ') + ') op de omvormer draaien, daarom de 6k5.');
      return redenen.length ? groot : basis;
    };

    let setKey;
    if (a.situatie === 'ess') setKey = fase === '3' ? 'ess-3f' : 'ess-1f';
    else if (fase === '3') setKey = 'solar-pro-3f';
    else setKey = 'solar-pro-1f';

    // Solar Easy: alleen 1-fase zonder zware verbruikers, als eenvoudig alternatief
    const easyMogelijk = a.situatie !== 'ess' && fase === '1' && !zwaar.length && !(a.bestaandePvKw > 0);

    let omv = kiesOmvormer(setKey);
    const pv = a.bestaandePvKw || 0;
    const omvRedenen = redenen.slice();
    if (pvPerFase(C.sets[setKey].fase) > C.omvormers[omv].va / (C.sets[setKey].fase === '3' ? 3 : 1)) {
      maatwerk('Je bestaande PV-omvormer (' + pv + ' kW) levert per fase meer dan de grootste Victron in de set (factor 1,0).');
    }

    uit.set = { key: setKey, naam: C.sets[setKey].naam, handle: C.sets[setKey].handle };
    uit.config.omvormer = { key: omv, label: C.omvormers[omv].label };

    if (setKey.endsWith('3f')) {
      uit.waarom.push(a.situatie === 'ess' && a.noodstroom === 'alles'
        ? 'Je wilt dat bij een storing alles blijft werken: dan is 3-fase nodig, want noodstroom werkt alleen op de fasen met een Victron.'
        : 'Je hebt een 3-fase aansluiting; met een 3-fase set heb je vermogen en noodstroom op alle fasen.');
    }
    omvRedenen.forEach((x) => uit.waarom.push(x));
    if (zwaar.length && !opNoodstroom && /4k5|3000/.test(omv)) uit.waarom.push('Je zware verbruikers draaien gewoon op het net; alleen de groepen op de noodstroom tellen voor het vermogen. Daarom volstaat de ' + C.omvormers[omv].label + '.');
    if (omv === '3x3000' || omv === '1x3000') uit.waarom.push('In België is de 3000 de basis, binnen de vermogensgrens van Fluvius.');
    if (a.land === 'BE' && (C.omvormers[omv].va > (fase === '3' ? 10 : 5))) {
      uit.meldingen.push('In België geldt zonder netstudie een grens van ' + (fase === '3' ? '10' : '5') + ' kVA. Volgens Fluvius is dat geen probleem als je geen terugleververgoeding vraagt; we checken dit met je.');
    }
    if (heeft(a.zwareVerbruikers, 'laadpaal')) uit.meldingen.push('De laadpaal sluiten we niet aan op de noodstroom; die blijft gewoon op het net.');

    // --- Accu ---------------------------------------------------------------
    const nodigDcKw = C.omvormers[omv].acKw / C.omvormerRendement;
    let bruikbaarDoel;
    if (a.situatie === 'solar-offgrid') {
      bruikbaarDoel = dag * C.panelen.offgridAutonomieDagen;
      uit.waarom.push('Off-grid: de accu dekt ' + C.panelen.offgridAutonomieDagen + ' dagen verbruik zonder zon.');
    } else if (heeft(a.doelen, 'noodstroom') && !heeft(a.doelen, 'zelfverbruik') && !heeft(a.doelen, 'dynamisch')) {
      bruikbaarDoel = 0; // kleinste geschikte maat
      uit.waarom.push('Je wilt vooral noodstroom: de kleinste accu die je omvormer aankan is genoeg.');
    } else if (heeft(a.doelen, 'dynamisch')) {
      bruikbaarDoel = dag * C.verbruik.dekkingDynamisch;
      uit.waarom.push('Met een dynamisch contract dekt de accu ongeveer een dag verbruik (' + nl(bruikbaarDoel) + ' kWh): je laadt als stroom goedkoop is en gebruikt hem als hij duur is, ook in de winter.');
    } else {
      bruikbaarDoel = dag * C.verbruik.nachtAandeel;
      uit.waarom.push('De accu dekt je verbruik in de avond en nacht (' + nl(bruikbaarDoel) + ' kWh). Groter loont alleen met een dynamisch contract: in de zomer heb je \'s nachts niet meer nodig en in de winter is er weinig zonne-overschot.');
    }
    let nominaalDoel = bruikbaarDoel / C.accu.praktijkFactor;
    if (a.situatie !== 'solar-offgrid' && nominaalDoel > C.verbruik.maxDoelPraktijkKwh / C.accu.praktijkFactor) {
      nominaalDoel = C.verbruik.maxDoelPraktijkKwh / C.accu.praktijkFactor;
      uit.waarom.push('Bij een groot verbruik begrenzen we het advies op ongeveer 32 kWh; groter kan, maar levert per extra kWh minder op.');
    }

    const accuGeschikt = (v) => {
      const m = C.accu.merken[v.merk];
      const kw = v.modules * m.maxKwPerModule;
      if (kw >= nodigDcKw) return { ok: true, krap: v.merk === 'dyness' && v.modules * m.aanbevolenKwPerModule < nodigDcKw };
      const uitzondering = C.accu.toegestaanOnderVermogen.some((u) => u.merk === v.merk && u.modules === v.modules && u.omvormer === omv);
      return uitzondering ? { ok: true, terugregelen: true } : { ok: false };
    };
    const opties = C.accu.varianten.filter((v) => v.fase.includes(C.sets[setKey].fase) && accuGeschikt(v).ok);
    const ladder = (merk) => opties.filter((v) => v.merk === merk).sort((x, y) => x.kwh - y.kwh);
    const eersteVanaf = (merk, kwh) => ladder(merk).find((v) => v.kwh >= kwh * C.accu.tolerantie - 0.01);

    // Merkkeuze (Joris 20-10): 1 Fidus als die genoeg is; anders Dyness, want die is per kWh altijd voordeliger
    // (1 Dyness ≈ 2 Fidus in prijs, met 16 in plaats van 10 kWh). Bij een trap of kelder Fidus.
    const eenFidus = ladder('fidus')[0];
    let accu = eenFidus && eenFidus.modules === 1 && eenFidus.kwh >= nominaalDoel * C.accu.tolerantie - 0.01 ? eenFidus
      : eersteVanaf('dyness', nominaalDoel) || eersteVanaf('fidus', nominaalDoel);
    if (a.accuPlek === 'trap-kelder' && accu && accu.merk === 'dyness') accu = eersteVanaf('fidus', nominaalDoel) || accu;
    if (a.accuPlek === 'trap-kelder' && (!accu || accu.merk === 'dyness') && ladder('fidus').length) {
      accu = ladder('fidus')[ladder('fidus').length - 1];
      uit.meldingen.push('Via een trap of kelder adviseren we Fidus (43 kg per module). De grootste Fidus-set dekt minder dan je dagverbruik; wil je meer, overleg dan over een andere plek.');
    }
    if (!accu) {
      maatwerk('Je hebt meer accu nodig (' + Math.round(nominaalDoel) + ' kWh) dan we online aanbieden.');
    } else {
      const g = accuGeschikt(accu);
      if (g.terugregelen) uit.meldingen.push('Eén Fidus levert continu ongeveer 5 kW. Staat er veel tegelijk aan, dan regelt het systeem terug; met 2 modules heb je het volle vermogen van de 6k5.');
      if (g.krap) uit.meldingen.push('Bij vol vermogen trekt de omvormer meer dan het aanbevolen vermogen van de PowerBrick; dat kan, maar een extra module geeft meer marge.');
      const minimum = opties.filter((v) => v.merk === accu.merk)[0];
      if (minimum === accu && bruikbaarDoel > 0 && accu.kwh > nominaalDoel * 1.5) uit.waarom.push('Je omvormer vraagt minimaal deze accu, ook al zou een kleinere qua kWh genoeg zijn.');
      uit.config.accu = {
        merk: accu.merk, naam: C.accu.merken[accu.merk].naam, modules: accu.modules, kwhNominaal: accu.kwh,
        kwhBruikbaarFabrikant: r1(accu.kwh * C.accu.dodFabrikant), kwhPraktijk: r1(accu.kwh * C.accu.praktijkFactor),
        variantId: accu.variantId, label: accuLabel(C, accu),
      };
      const ander = eersteVanaf(accu.merk === 'fidus' ? 'dyness' : 'fidus', nominaalDoel);
      if (ander && !(a.accuPlek === 'trap-kelder' && ander.merk === 'dyness')) {
        const verschil = Math.round(((ander.prijs - accu.prijs) * 1.21) / 10) * 10;
        const prijsTekst = verschil > 0 ? ' Ongeveer ' + euro(verschil) + ' duurder.' : verschil < 0 ? ' Ongeveer ' + euro(-verschil) + ' goedkoper.' : '';
        uit.alternatieven.push({ soort: 'accu', label: accuLabel(C, ander), toelichting: (ander.merk === 'dyness' ? 'Meer kWh voor je geld, één module van 119 kg op de vloer.' : 'Lichter (43 kg per module), aan de wand; minder kWh voor je geld.') + prijsTekst });
      }
    }

    // --- Panelen (solar) -----------------------------------------------------
    if (a.situatie !== 'ess') {
      const kwpPerPaneel = C.panelen.wp / 1000;
      const ori = C.panelen.orientatie[a.orientatie || 'zuid'];
      let nodig;
      if (a.situatie === 'solar-offgrid') {
        nodig = dag / (kwpPerPaneel * C.panelen.offgridKwhPerKwpPerDag * ori * C.panelen.offgridSysteemverlies);
      } else {
        nodig = jaar / (kwpPerPaneel * C.panelen.opbrengstKwhPerKwp * ori);
      }
      const keuzes = C.sets[setKey].panelen;
      // Verbruik onbekend en dak bekend: zoals sales, het dak zo goed mogelijk vullen
      if (verbruikGeschat && a.dakPanelenMax && a.situatie !== 'solar-offgrid') nodig = Math.max(nodig, a.dakPanelenMax);
      let aantal = keuzes.find((n) => n >= nodig) || null;
      if (!aantal) {
        if (setKey === 'solar-pro-3f') maatwerk('Je hebt meer dan ' + keuzes[keuzes.length - 1] + ' panelen nodig.');
        aantal = keuzes[keuzes.length - 1];
        uit.meldingen.push(a.situatie === 'solar-offgrid'
          ? 'Ook met ' + aantal + ' panelen dek je de winter niet. Reken op een aggregaat van november tot februari.'
          : 'Met ' + aantal + ' panelen (het maximum van deze set) dek je niet je hele jaarverbruik; de rest komt van het net.');
      }
      if (a.dakPanelenMax && aantal > a.dakPanelenMax) {
        const past = keuzes.filter((n) => n <= a.dakPanelenMax);
        if (!past.length) maatwerk('Er passen minder dan ' + keuzes[0] + ' panelen op je dak; dat is kleiner dan de kleinste set.');
        else { aantal = past[past.length - 1]; uit.meldingen.push('Er passen ' + a.dakPanelenMax + ' panelen op je dak; we adviseren er ' + aantal + '. Daarmee dek je minder dan je verbruik.'); }
      }
      uit.config.panelen = { aantal, wp: C.panelen.wp, kwp: r1(aantal * kwpPerPaneel), nodigBerekend: r1(nodig) };
      uit.waarom.push(a.situatie === 'solar-offgrid'
        ? aantal + ' panelen van ' + C.panelen.wp + ' Wp, gerekend op voorjaar tot najaar.'
        : aantal + ' panelen van ' + C.panelen.wp + ' Wp leveren ongeveer ' + Math.round(aantal * kwpPerPaneel * C.panelen.opbrengstKwhPerKwp * ori) + ' kWh per jaar.');
      if (a.situatie === 'solar-offgrid') {
        uit.meldingen.push('Van november tot februari levert een paneel in Nederland en België zo weinig dat geen dak de winter dekt. Woon je er het hele jaar, dan heb je een aggregaat nodig.');
        const meer = keuzes.filter((n) => n > aantal && (!a.dakPanelenMax || n <= a.dakPanelenMax));
        if (meer.length) uit.meldingen.push('Past het op je dak, dan zijn meer panelen (bijvoorbeeld ' + meer[0] + ') de goedkoopste manier om minder uren met de aggregaat te draaien.');
      }

      if (easyMogelijk && aantal <= 16) {
        uit.alternatieven.push({ soort: 'set', key: 'solar-easy', label: C.sets['solar-easy'].naam, toelichting: 'Alles-in-1 en voordeliger, met minder vermogen (' + C.omvormers[kiesOmvormer('solar-easy')].label + '). Minder ruimte om uit te breiden.' });
      }
    }

    // --- 1-fase-alternatief op een 3-fase aansluiting -----------------------
    if (fase === '3' && a.situatie !== 'solar-offgrid' && a.noodstroom !== 'alles' && !heeft(a.zwareVerbruikers, 'warmtepomp')) {
      const alt = a.situatie === 'ess' ? 'ess-1f' : 'solar-pro-1f';
      uit.alternatieven.push({ soort: 'set', key: alt, label: C.sets[alt].naam, toelichting: 'Goedkoper. Werkt ook op een 3-fase aansluiting (de slimme meter telt de fasen op), maar noodstroom heb je dan op één fase.' });
    }

    // --- Besparing (plan §3a) ------------------------------------------------
    if (a.situatie !== 'solar-offgrid' && uit.config.accu) {
      const B = C.besparing[a.land || 'NL'];
      const alleenNood = heeft(a.doelen, 'noodstroom') && !heeft(a.doelen, 'zelfverbruik') && !heeft(a.doelen, 'dynamisch');
      if (alleenNood) {
        uit.besparing = { soort: 'zekerheid', tekst: 'Je kiest vooral voor zekerheid bij een storing, niet voor besparing.' };
      } else {
        const prak = uit.config.accu.kwhPraktijk;
        const max = dag * C.verbruik.nachtAandeel * 365;
        const laag = Math.min(prak * C.besparing.cycliZelfverbruik, max) * B.waardeKwh[0];
        let hoog = Math.min(prak * C.besparing.cycliZelfverbruik, max) * B.waardeKwh[1];
        if (heeft(a.doelen, 'dynamisch')) hoog = Math.min(prak * C.besparing.cycliDynamisch, max) * (B.waardeKwh[1] + B.dynamischExtra[1]);
        let capLaag = 0, capHoog = 0;
        if (B.capaciteit) { capLaag = B.capaciteit.kwAfvlakking[0] * B.capaciteit.euroPerKwJaar[0]; capHoog = B.capaciteit.kwAfvlakking[1] * B.capaciteit.euroPerKwJaar[1]; }
        const rond = (x) => Math.round(x / 10) * 10;
        uit.besparing = {
          soort: 'indicatie', min: rond(laag + capLaag), max: rond(hoog + capHoog),
          aannames: [
            'Ongeveer ' + C.besparing.cycliZelfverbruik + (heeft(a.doelen, 'dynamisch') ? '–' + C.besparing.cycliDynamisch : '') + ' volle laadcycli per jaar met ' + prak + ' kWh bruikbaar in de praktijk.',
            'Waarde van een eigen kWh: €' + B.waardeKwh[0].toFixed(2) + '–' + B.waardeKwh[1].toFixed(2) + (a.land === 'BE' ? ' (afname min injectievergoeding).' : ' (afname min terugleververgoeding, na het einde van salderen).'),
          ].concat(B.capaciteit ? ['Capaciteitstarief: de accu vlakt je piek af met ' + B.capaciteit.kwAfvlakking.join('–') + ' kW.'] : [])
           .concat(a.land !== 'BE' ? ['Tot 1-1-2027 saldeer je nog; de besparing begint vooral daarna.'] : []),
        };
      }
    }

    // --- Installatie (optioneel) --------------------------------------------
    if (a.installatie) {
      const I = C.installatie[a.land || 'NL'];
      const pc = parseInt(String(a.postcode || '').replace(/\D/g, '').slice(0, 4), 10);
      const inGebied = pc && I.postcodes.some(([v, t]) => pc >= v && pc <= t);
      const essSet = setKey.startsWith('ess');
      let prijs = null;
      if (inGebied && (essSet || !I.alleenEss)) {
        if (essSet) prijs = I.prijzen[setKey];
        else {
          const tabel = I.prijzen[setKey.endsWith('3f') ? 'solar-3f' : 'solar-1f'];
          const n = (uit.config.panelen || {}).aantal || 0;
          const rij = tabel.find((t) => n <= t.tot);
          prijs = rij ? rij.prijs : null;
        }
      }
      uit.installatie = prijs
        ? { mogelijk: true, vanafPrijs: prijs, tekst: 'Installatie in jouw regio kan, vanaf €' + prijs.toLocaleString('nl-NL') + '. We bevestigen dit na een korte intake.' }
        : { mogelijk: false, tekst: pc ? 'In jouw regio installeren we deze set niet zelf, maar we helpen je graag verder.' : 'Vul je postcode in om te zien of we bij jou installeren.' };
    }

    // --- Maatwerk en productlink --------------------------------------------
    if (uit.maatwerkRedenen.length) uit.status = 'maatwerk';
    const p = new URLSearchParams();
    p.set('advies', [
      'omv:' + omv,
      uit.config.accu ? 'accu:' + uit.config.accu.merk + '-' + uit.config.accu.modules : null,
      uit.config.accu ? 'vid:' + uit.config.accu.variantId : null,
      uit.config.panelen ? 'pan:' + uit.config.panelen.aantal : null,
      a.noodstroom && a.situatie !== 'solar-offgrid' ? 'nood:' + a.noodstroom : null,
      a.situatie === 'solar-net' ? 'net:ess' : a.situatie === 'solar-offgrid' ? 'net:offgrid' : null,
    ].filter(Boolean).join(';'));
    uit.productUrl = '/products/' + uit.set.handle + '?' + p.toString();
    return uit;
  }

  const api = { advies };
  if (typeof module !== 'undefined') module.exports = api;
  else root.SOSysteemkeuze = api;
})(this);
